import React, { useState, useEffect, useRef } from 'react';
import { MDBDataTable } from 'mdbreact';
import { Form } from 'react-bootstrap';
import { Button, Container, IconButton } from '@mui/material';
import Select from "react-select";
import { baseURL } from '../base_url';
import axios from 'axios';
import moment from 'moment';
import { PuffLoader } from 'react-spinners';
import { read, utils, writeFile } from 'xlsx';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Swal from 'sweetalert2';
import { FaUpload } from "react-icons/fa";
import dayjs from 'dayjs';
import "./tolls.css";

const chargeTypeLabels = {
    'charge_at_counter': 'Charged At Counter',
    'penalty_imposed': 'Penalty Imposed',
    'governemnt_reservation': 'Government Reservation',
};

function formatLocationDate(locationDateTime) {
    const parsedDate = dayjs(locationDateTime, 'YYYY-MM-DD HH:mm:ss A');
    return parsedDate.format('MM/DD/YYYY hh:mm A');
}

const Tolls = () => {
    const [accessDetails, setAccessDetails] = useState([]);
    const [loading, setLoading] = useState(false);
    const [exportTableData, setExportTableData] = useState([]);
    const [locationItems, setLocationItems] = useState([])
    const [selectedLocation, setSelectedLocation] = useState({ label: "All", value: "0" })

    const loggedInUser = sessionStorage.getItem("tm_token");
    const foundUser = JSON.parse(loggedInUser);
    const [selectedFromDate, setSelectedFromDate] = useState(new Date(new Date().setDate(new Date().getDate() - 2)));
    const [selectedToDate, setSelectedToDate] = useState(new Date());

    const [excelUploadCount, setExcelUploadCount] = useState('')
    const fileInputRef = useRef(null); 

    const [userItems, setUserItems] = useState([])
    const [selectedUser, setSelectedUser] = useState({ label: "All", value: "0" })
    const [selectedChargeType, setSelectedChargeType] = useState({ label: "All", value: "0" })
    const [selectedStatus, setSelectedStatus] = useState({ label: "All", value: "0" });
    const [selectedApi, setSelectedApi] = useState({ label: "All", value: "0" })
    const statusItems = [
        { value: '0', label: 'All' },
        { value: 'Open', label: 'Open' },
        { value: 'Closed', label: 'Closed' },
        { value: 'Processing', label: 'Processing' },
    ];
    
    const handleStatusChange = (selectedOption) => {
        setSelectedStatus(statusItems.find(option => option.value === selectedOption.value));
        return false;
    };

    const apiItems = [
        { value: '0', label: 'All' },
        { value: 'stellantis', label: 'Stellantis' },
        { value: 'ford', label: 'Ford' },
        { value: 'vw', label: 'Volkswagon' },
        { value: 'ridesiq', label: 'RidesIQ'},
        { value: 'nissan', label: 'Nissan'}
    ];

    const chargeTypeItems = [
        { value: '0', label: 'All' },
        { value: 'charge_at_counter', label: 'Charged At Counter' },
        { value: 'penalty_imposed', label: 'Penalty Imposed' },
        { value: 'pending', label: 'Pending' },
        { value: 'one_way', label: 'One-Way Rental' },
        { value: 'corporate', label: 'Corporate'},
        { value: 'governemnt_reservation', label: 'Government Reservation'},
        { value: 'wrong_alert', label: 'Wrong Alert' }
    ];
    
    const handleChargeTypeChange = (selectedOption) => {
        setSelectedChargeType(chargeTypeItems.find(option => option.value === selectedOption.value));
        return false;
    };

    const handleUserChange = (selectedOption) => {
        setSelectedUser(userItems.find(option => option.value === selectedOption.value));
        return false;
    };

    const handleApiChange = (selectedOption) => {
      setSelectedApi(apiItems.find(option => option.value === selectedOption.value))
      return false;
    }
    
    useEffect(() => {
        axios.get(baseURL + "/get_location_setup_for_tolls?status=active&admin_id=" + foundUser['tm_id']).then((res) => {
            const allOption = { label: "All", value: "0" };
            const menuList2 = res.data.data.map((val1) => {
            return { label: val1.location_name, value: val1._id }
            })
            setLocationItems([allOption, ...menuList2])
            alertData();
        });
        axios.get(baseURL + "/get_all_users_for_tolls?status=active")
        .then((res) => {
            const allUsersOption = { label: "All", value: "0" };
            const usersList = Array.isArray(res.data)
                ? res.data.map((user) => ({
                      label: user.user_name,
                      value: user.id,
                  }))
                : [];
    
            setUserItems([allUsersOption, ...usersList]);
    
        })
        .catch((error) => {
            console.error("Error fetching users:", error);
            setUserItems([{ label: "All", value: "0" }]);
        });
    },[]);    
    const handleLocationChange = (selectedOption) =>{
        setSelectedLocation(locationItems.find(option => option.value === selectedOption.value))
        return false;
    }
    const alertData = () => {
        const fromDate = new Date(selectedFromDate).toDateString()
        const toDate = new Date(selectedToDate).toDateString()
        setLoading(true);

        let url = baseURL + "/get_tolls_details" +
        "?from=" + fromDate +
        "&to=" + toDate +
        "&location=" + selectedLocation.value +
        "&status=" + selectedStatus.value +
        "&charge_type=" + selectedChargeType.value +
        "&admin_id=" + selectedUser.value;

        // Only add api_type if it is selected (not "0")
        if (selectedApi?.value && selectedApi.value !== "0") {
            url += "&api_type=" + selectedApi.value;
        }

        axios.get(url).then((res) => {
            var j = 1;
            setLoading(false);
            if(res.data.status === '1'){
                let rowsData = [];
                let ExportTableData = [];
                const myDataSet = res.data.data;
                for (var index = 0; index < res.data.data.length; index++) {
                    let rowItem = {};
                    const val = myDataSet[index];
                    let updated_datetime = ''
                    let toll_datetime = ''
                    let tollType =
                        val.road_id === "31"
                            ? (val.road_address?.trim().toLowerCase() === "florida's turnpike"
                                ? "Sunpass Toll"
                                : "Maimi Toll")
                            : (["1","2","3","4","5","6","7","8","9","10","11","12"].includes(val.road_id)
                                ? "Sunpass Toll"
                                : "");
                    if (val.toll_pass_status === 1 && val.toll_type) {
                        tollType = tollType ? `${tollType}, ${val.toll_type}` : val.toll_type;
                    }
                    rowItem["id"] = j;
                    rowItem["vin"] = val.vin;
                    rowItem["plate"] = val.plate;
                    rowItem["location"] = val.loc_name;
                    rowItem['road_address'] = (
                    <div className="cell-ellipsis" style={{ maxWidth: "50px" }} title={val.plate}>
                        {val.road_address}
                    </div>
                    );
                    rowItem['toll_type'] = tollType
                    rowItem["agreement_status"] = (
                    <div className="cell-ellipsis" style={{ maxWidth: "50px" }} title={val.plate}>
                        {val.agreement_status}
                    </div>
                    );
                    rowItem["agreement_number"] = val.agreement_number;
                    rowItem["alert_from"] = (
                    <div className="cell-ellipsis" style={{ maxWidth: "50px" }} title={val.plate}>
                        {val.alert_from}
                    </div>
                    );
                    rowItem["charge_status"] = val.charge_status;
                    rowItem['charge_option'] = chargeTypeLabels[val.charge_option] || val.charge_option;
                    rowItem['charge_total'] = parseFloat(val.charge_total).toFixed(2);
                    rowItem['c_date'] = formatLocationDate(val.location_datetime_c);
                    toll_datetime = formatLocationDate(val.toll_datetime);
                    rowItem["updated_by"] = val.added_by;
                    rowItem["comment"] = (
                    <div className="cell-ellipsis" style={{ maxWidth: "50px" }} title={val.plate}>
                        {val.comment}
                    </div>
                    );
                    rowItem['action'] = (
                        <Button
                            size="small"
                            onClick={() =>
                            handleLogDetails(
                                encodeBase64(val.id),
                                encodeBase64(val.agreement_number),
                                encodeBase64(val.road_id),
                                encodeBase64(val.vin)
                            )
                            }
                            variant="contained"
                        >
                            Details
                        </Button>
                    );
                    ExportTableData.push([j, val.vin, val.plate, val.loc_name, val.road_address ,rowItem['toll_type'],val.agreement_status, val.agreement_number, val.alert_from ,rowItem["charge_status"],rowItem['charge_option'],rowItem['charge_total'],val.comment,rowItem['c_date'],val.added_by,toll_datetime]);
                    rowsData.push(rowItem)
                    j++;
                }
                setExportTableData(ExportTableData)
                setAccessDetails(rowsData);
            }else{
                setAccessDetails([]);
            }
        });
    }
    const encodeBase64 = (value) => {
        const bytes = new TextEncoder().encode(String(value));
        let binary = "";

        bytes.forEach((byte) => {
            binary += String.fromCharCode(byte);
        });

        return btoa(binary);
        };
    const submitDate = () => {
      alertData();
    }
    const data = {
        columns: [
            {
                label: 'S.No',
                field: 'id',
            },
            {
                label: 'VIN',
                field: 'vin',
            },
            {
                label: 'Plate',
                field: 'plate',
            },
            {
                label: 'Location',
                field: 'location',
            },
            {
                label: 'Toll Road',
                field: 'road_address',
            },
            {
                label: 'Toll Type',
                field: 'toll_type',
            },
            {
                label: 'Agree. Status',
                field: 'agreement_status',
            },
            {
                label: 'Agree. Number',
                field: 'agreement_number',
            },
            {
                label: 'Alert From',
                field: 'alert_from',
            },
            {
                label: 'Status',
                field: 'charge_status',
            },
            {
                label: 'Charge Type',
                field: 'charge_option',
            },
            {
                label: 'Charged Total',
                field: 'charge_total',
            },
            {
                label: 'Comment',
                field: 'comment',
            },
            {
                label: 'Updated By',
                field: 'updated_by',
            },
            {
                label: 'Location DateTime',
                field: 'c_date',
            },
            {
                label: 'Action',
                field: 'action',
            },
        ],
        rows: accessDetails
    };
    const handleExportTableData = () => {
        const headings = [['S.No','VIN Number','Plate','Location','Toll Road','Toll Type','Agreement Status','Agreement Number', 'Alert From','Status','Charge Type','Charged Amount','Comment','Created datetime','Created By','Toll Datetime']];
        const sampleVin = exportTableData;
        const wb = utils.book_new();
        const ws = utils.json_to_sheet([]);
        utils.sheet_add_aoa(ws, headings);
        utils.sheet_add_json(ws, sampleVin, { origin: 'A2', skipHeader: true });
        utils.book_append_sheet(wb, ws, 'Alert List');
        writeFile(wb, 'Tolls List.xlsx');
    }
    const handleLogDetails = (iid,agree_num,road,vin) => {
        window.open('/toll_maps?iid=' + iid+'&id=' + agree_num+'&road='+road+'&vin='+vin, '_blank');
    };

    const handleImportTollPass = async ($event) => {
      const files = $event.target.files;
      if (files.length) {
          const file = files[0];
          const formData = new FormData();
          formData.append('file', file);
          formData.append('admin_id', foundUser['tm_id']);

          const reader = new FileReader();
          reader.onload = async (event) => {
              const wb = read(event.target.result);
              const sheets = wb.SheetNames;
              if (sheets.length) {
                  const rows = utils.sheet_to_json(wb.Sheets[sheets[0]], { header: 1, defval: "" });
                  if (rows[0].includes("R/A Number") && rows[0].includes("Drop Off Date") && rows[0].includes("Optional Service List")) {
                      const data = utils.sheet_to_json(wb.Sheets[sheets[0]]);
                      if (data.length > 4000) {
                          setLoading(false);
                          Swal.fire({
                              icon: 'error',
                              text: "Oops! Your file size is " + data.length + ", but the maximum allowed size is 4000. Please reduce your file size and try again."
                          });
                          return false;
                      }
                      if (data.length > 0) {
                          setLoading(true);
                          setExcelUploadCount('Uploading...');
                          try {
                              // Send the entire dataset at once
                              await axios.post(baseURL + "/upload_fleet_excel_tolls", {
                                  data: JSON.stringify(data),
                                  admin_id: foundUser['tm_id']
                              });

                              setExcelUploadCount('');
                              Swal.fire({
                                  icon: 'success',
                                  text: "Tolls Data have been updated successfully."
                              }).then(() => {
                                  window.location.reload();
                              });
                          } catch (error) {
                              console.error('Error uploading data:', error);
                              Swal.fire({
                                  icon: 'error',
                                  text: 'Failed to upload data.'
                              });
                          } finally {
                              setLoading(false);
                          }
                      } else {
                          Swal.fire({
                              icon: 'error',
                              text: 'You have uploaded an empty file.'
                          });
                          return;
                      }
                  } else {
                      Swal.fire({
                          icon: 'error',
                          text: 'You have uploaded an invalid file. Please download the sample template for your reference.'
                      });
                      return;
                  }
              }
          };
          reader.readAsArrayBuffer(file);
      }
      fileInputRef.current.value = '';
    };




    return (
    <div className='body_class' style={{marginLeft:"13vw",paddingLeft:"20px",paddingRight:"20px"}}>
        {loading ? (
            <div className="loader-overlay">
                <div className="loader">
                    {excelUploadCount ? <div className="excel-upload-count">{excelUploadCount}</div> : null}
                    <PuffLoader color="#00308F" loading={true} size={200} />
                </div>
            </div>
        ) : ("")}
        <h5>Tolls Alerts</h5>
        <div className='row p-4'>
            <div className="col-auto mt-1">
                <label htmlFor="datepicker" className="form-label">Start Date:</label>
            </div>
            <div className='col-2'>
                <DatePicker
                id="datepicker"
                selected={selectedFromDate}
                onChange={(date) => setSelectedFromDate(date)}
                className="form-control" // Bootstrap class for input fields
                />
            </div>
            <div className="col-auto mt-1">
                <label htmlFor="datepicker" className="form-label">To Date:</label>
            </div>
            <div className='col-2'>
                <DatePicker
                id="datepicker"
                selected={selectedToDate}
                onChange={(date) => setSelectedToDate(date)}
                className="form-control" // Bootstrap class for input fields
                />
            </div>
            <div className="col-auto mt-1">
                <label htmlFor="Location" className="form-label">Location:</label>
            </div>
            <div className='col-2'>
                <Select placeholder="Select Location" options={locationItems} onChange={handleLocationChange} value={selectedLocation}/>
            </div>
            
            <div className="col-auto mt-1">
                <label htmlFor="Status" className="form-label">Status:</label>
            </div>
            <div className='col-2'>
                <Select placeholder="Select Status" options={statusItems} onChange={handleStatusChange} value={selectedStatus} />
            </div>
        </div>
        <div className='row' style={{ marginLeft: "14px" }}>
            <div className="col-auto mt-1">
                <label htmlFor="ChargeType" className="form-label">Charge Type:</label>
            </div>
            <div className='col-3'>
                <Select placeholder="Select Charge Type" options={chargeTypeItems} onChange={handleChargeTypeChange} value={selectedChargeType} />
            </div>
            <div className="col-auto mt-1">
                <label htmlFor="UpdatedBy" className="form-label">Updated By:</label>
            </div>
            <div className='col-2'>
                <Select placeholder="Select User" options={userItems} onChange={handleUserChange} value={selectedUser} />
            </div>
            {/* New changes - Added API dropdown */}
            <div className="col-auto mt-1">
                <label htmlFor="Status" className="form-label">API:</label>
            </div>
            <div className='col-2'> 
                <Select placeholder="Select User" options={apiItems} onChange={handleApiChange} value={selectedApi}/>
            </div>
            <div className='col-1'>
                <Button variant="contained" onClick={submitDate}>Submit</Button>
            </div>
        </div>
        <div className='row' style={{ marginLeft: "14px" }}>
            <div className='col-auto mt-1'>
                <input
                    type="file"
                    id="select-csv2"
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    style={{ display: 'none' }}
                    multiple={true}
                    required
                    onChange={handleImportTollPass}
                    ref={fileInputRef}
                />
                <label htmlFor="select-csv2">
                    <Button size='large' variant="contained" className="btn btn-primary" component="span">
                        <FaUpload size={14} />&nbsp;Upload Toll Pass Excel
                    </Button>
                </label>
            </div>
        </div>
        <br></br>
        <div style={{ position: "absolute", marginTop:"-5px", padding:"7px"}}>
            <Button size='small' variant="contained" onClick={handleExportTableData}>Export Excel</Button>
        </div>
        <div className="row mt-1">
            <div className="col-md-12">
                <MDBDataTable
                    bordered
                    data={data}
                    large={false}
                    displayEntries={false}
                    search={true}
                    noBottomColumns={true}
                    className="pagination-right-aligned"
                    searching={true}
                />
            </div>
        </div>
    </div>
    );
};

export default Tolls;
